// extracted by mini-css-extract-plugin
export var infoItem = "_qs-2";
export var title = "_qs-0";
export var value = "_qs-1";